export const UPDATE_NEW_PAYMENT = 'UPDATE_NEW_PAYMENT';
export const SET_PAYMENT = 'SET_PAYMENT';
export const APPLY_INVOICE_AMOUNT = 'APPLY_INVOICE_AMOUNT';
export const SET_INVOICES_TO_PAY = 'SET_INVOICES_TO_PAY';
export const SET_PAYMENTS = 'SET_PAYMENTS';
export const SET_OFFSET = 'SET_OFFSET';
export const SET_IPD_PAYMENT = 'SET_IPD_PAYMENT';
export const SET_PAYPAL_OFFSET = 'SET_PAYPAL_OFFSET';
export const SET_STRIPE_OFFSET = 'SET_STRIPE_OFFSET';
